import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Heading,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  InputLeftAddon,
  InputGroup,
  NumberInput,
  NumberInputField,
  useBreakpointValue,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'
import { keyframes } from '@emotion/react';
import axios from 'axios';

const countries = [
  {
    name: "Bénin",
    id: 1,
    //icon: "https://flagcdn.com/20x15/bj.png",
    icon: '🇧🇯',
    code: "+229"
  },
  {
    name: "Burkina Faso",
    id: 2,
    //icon: "https://flagcdn.com/20x15/bf.png",
    icon: '🇧🇫',
    code: "+226"
  },
  {
    name: "Cap-Vert",
    id: 3,
    //icon: "https://flagcdn.com/20x15/bf.png",
    icon: '🇨🇻',
    code: "+238"
  },
  {
    name: "Côte d'Ivoire",
    id: 4,
    //icon:"https://flagcdn.com/20x15/ci.png",
    icon: '🇨🇮',
    code: "+225"
  },
  {
    name: "Gambie",
    id: 5,
    //icon: "https://flagcdn.com/20x15/gh.png",
    icon: '🇬🇲',
    code: "+220"
  },
  {
    name: "Ghana",
    id: 6,
    //icon: "https://flagcdn.com/20x15/gh.png",
    icon: '🇬🇭',
    code: "+233"
  },
  {
    name: "Guinée",
    id: 7,
    //icon: "https://flagcdn.com/20x15/ml.png",
    icon: '🇬🇳',
    code: "+224"
  },
  {
    name: "Guinée-Bissau",
    id: 8,
    //icon: "https://flagcdn.com/20x15/ml.png",
    icon: '🇬🇼',
    code: "+245"
  },
  {
    name: "Libéria",
    id: 9,
    //icon: "https://flagcdn.com/20x15/ml.png",
    icon: '🇱🇷',
    code: "+231"
  },
  {
    name: "Mali",
    id: 10,
    //icon: "https://flagcdn.com/20x15/ml.png",
    icon: '🇲🇱',
    code: "+223"
  },
  {
    name: "Mauritanie",
    id: 11,
    //icon: "https://flagcdn.com/20x15/ml.png",
    icon: '🇲🇷',
    code: "+222"
  },
  {
    name: "Niger",
    id: 12,
    //icon:"https://flagcdn.com/20x15/ne.png",
    icon: '🇳🇪',
    code: "+227"
  },
  {
    name: "Nigeria",
    id: 13,
    //icon: "https://flagcdn.com/20x15/ng.png",
    icon: '🇳🇬',
    code: "+234"
  },
  {
    name: "Sénégal",
    id: 14,
    //icon: "https://flagcdn.com/20x15/sn.png",
    icon: '🇸🇳',
    code: "+221"
  },
  {
    name: "Sierra Leone",
    id: 15,
    //icon: "https://flagcdn.com/20x15/ml.png",
    icon: '🇸🇱',
    code: "+232"
  },
  {
    name: "Togo", 
    id: 16,
    //icon:"https://flagcdn.com/20x15/tg.png",
    icon: '🇹🇬',
    code: "+228"
  },
]

const shake = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
`;

const Form = () => {
  const [selectedCountry, setSelectedCountry] = useState("")
  const [selectedCodeCountry, setSelectedCodeCountry] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [city, setCity] = useState("")
  const toast = useToast();
  const toastIdRef = useRef()
  const navigate = useNavigate();

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value)
  }

  const handleLastNameChange = (event) => {
    setLastName(event.target.value)
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handleCityChange = (event) => {
    setCity(event.target.value)
  }

  const handleCountryChange = (event) => {
    const country = countries.find(c => c.name === event.target.value)
    setSelectedCountry(country ? country.name : "")
    setSelectedCodeCountry(country ? country.code : "")
  }
  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value)
  }

  const [isValideFirtName, setIsValideFirtName] = useState(false)
  const [isValideLastName, setIsValideLastName] = useState(false)
  const [isValideEmail, setIsValideEmail] = useState(false)
  const [isValidePhoneNumber, setIsValidePhoneNumber] = useState(false)
  const [isValideCity, setIsValideCity] = useState(false)
  const [isValideCountry, setIsValideCountry] = useState(false)

  const headingFontSize = useBreakpointValue({ base: 'lg', md: '2xl' });
  const subHeadingFontSize = useBreakpointValue({ base: 'lg', md: '2xl' });
  const flexDirection = useBreakpointValue({ base: 'column', md: 'row' });
  const formControlMarginRight = useBreakpointValue({ base: 0, md: "5%" });
  const formControlMarginBottom = useBreakpointValue({ base: 4, md: 0 });

  const handleButtonClick = async () => {
    // Reset animation state
    setIsValideFirtName(false);
    setIsValideLastName(false);
    setIsValideEmail(false);
    setIsValidePhoneNumber(false);
    setIsValideCity(false);
    setIsValideCountry(false);

    // Check validity of each field
    if (!firstName) {
      setIsValideFirtName(true);
    }
    if (!lastName) {
      setIsValideLastName(true);
    }
    if (!email) {
      setIsValideEmail(true);
    }
    if (!phoneNumber) {
      setIsValidePhoneNumber(true);
    }
    if (!city) {
      setIsValideCity(true);
    }
    if (!selectedCountry) {
      setIsValideCountry(true);
    }

    // If all fields are valid, send data to the server
    if (firstName && lastName && email && phoneNumber && selectedCountry && city) {
      try {
        toastIdRef.current = toast({
          icon: <Spinner />,       
          title: "Inscription en cours",
          description: "Veuillez patienter...",
          status: "loading",
          duration: null,
          isClosable: true,
        });
        const response = await axios.post('https://cicabank.com/survey/registration', {
          firstName,
          lastName,
          country: selectedCountry,
          phone: `${selectedCodeCountry}${phoneNumber}`, // Concatenate country code and phone number
          email: email,
          city
        });
        if (response.status === 201) {
          if (toastIdRef.current) {
            toast.update(toastIdRef.current, {
              title: "Inscription réussie",
              description: "Merci de t'être inscrit sur notre liste d'attente.",
              status: "success",
              duration: 5000,
              isClosable: true,
            })
          }
          navigate(`/complete-survey/${response.data.token}`);
        }
      } catch (error) {
        toast.update(toastIdRef.current, {
          title: "Erreur lors de l'inscription",
          description: "Une erreur s'est produite lors de l'inscription. Veuillez réessayer.",
          status: "error",
          duration: 9000,
          isClosable: true,
        })
        console.error('Error during registration:', error);
      }
    }
  }

  return (
    <>
      <Box 
        id='form'
        borderWidth="1px"
        rounded="lg"
        shadow="2px 2px 6px rgba(0,0,0,0.3)"
        minH={{ base: 600, md: 750 }}
        maxWidth={{ base: "96%", md: 1000 }}
        m="30px auto"
        as="form"
        alignContent={'center'}
        bgColor={'blackAlpha.900'}>
        <Heading p={useBreakpointValue({ base: '2', md: '4' })} w="100%" fontSize={headingFontSize} textAlign={'center'} fontWeight="bold" mb={useBreakpointValue({ base: '5%', md: '5%' })} color={'black'} roundedTop={'lg'} bgColor={'#FFD700'} h={'auto'}>
          Rejoins notre liste d’attente maintenant
        </Heading>
        <Heading p={useBreakpointValue({ base: '2', md: '4' })} w="100%" fontSize={subHeadingFontSize} textAlign={'center'} fontWeight="normal" mb="5%" color={'white'}>
          Profite d’avantages exclusifs dès notre lancement !
        </Heading>
        <Flex mb="3%" direction={flexDirection} p={useBreakpointValue({ base: '2', md: '4' })}>
          <FormControl mr={formControlMarginRight} mb={formControlMarginBottom} animation={isValideFirtName && !firstName ? `${shake} 0.5s` : ''}>
            <FormLabel htmlFor="first-name" fontWeight={'normal'} color={'white'}>
              Prénom
            </FormLabel>
            <Input id="first-name" placeholder="Entrez votre prénom" color={'black'} bg={'white'} focusBorderColor="#FFD700" value={firstName} onChange={handleFirstNameChange} isInvalid={isValideFirtName && !firstName} errorBorderColor='crimson' />
          </FormControl> 
          <FormControl animation={isValideLastName && !lastName ? `${shake} 0.5s` : ''}>
            <FormLabel htmlFor="last-name" fontWeight={'normal'} color={'white'}>
              Nom
            </FormLabel>
            <Input id="last-name" placeholder="Entrez votre nom" color={'black'} bg={'white'} focusBorderColor="#FFD700" value={lastName} onChange={handleLastNameChange} isInvalid={isValideLastName && !lastName} errorBorderColor='crimson' />
          </FormControl>
        </Flex>      
        <FormControl p={useBreakpointValue({ base: '2', md: '4' })} mb="3%" animation={isValideCountry && !selectedCountry ? `${shake} 0.5s` : ''}>
          <FormLabel htmlFor="country" fontWeight={'normal'} color={'white'}>
            Pays de résidence
          </FormLabel>
          <Select placeholder="Choisissez votre pays" color={'black'} bg={'white'} onChange={handleCountryChange} focusBorderColor="#FFD700" isInvalid={isValideCountry && !selectedCountry} errorBorderColor='crimson' >
            {countries.map((country) => (
              <option key={country.id} value={country.name} >
                {country.icon} {country.name}
              </option>
            ))}
          </Select>
        </FormControl>
        <FormControl p={useBreakpointValue({ base: '2', md: '4' })} mb="3%" animation={isValidePhoneNumber && !phoneNumber ? `${shake} 0.5s` : ''}>
          <FormLabel htmlFor="phone" fontWeight={'normal'} color={'white'}>
            Numéro de téléphone
          </FormLabel>
          <InputGroup>
            <InputLeftAddon children={selectedCodeCountry} />
            <NumberInput color={'black'} bg={'white'} w={'100%'} focusBorderColor="#FFD700" isInvalid={isValidePhoneNumber && !phoneNumber} errorBorderColor='crimson'>
              <NumberInputField id="phone" placeholder="Entrez votre numéro de téléphone" value={phoneNumber} onChange={handlePhoneNumberChange} />
            </NumberInput>
            {/* <Input id="phone" placeholder="Entrez votre numéro de téléphone" value={phoneNumber} onChange={handlePhoneNumberChange} /> */}
          </InputGroup>
        </FormControl>
        <FormControl p={useBreakpointValue({ base: '2', md: '4' })} mb="3%" animation={isValideEmail && !email ? `${shake} 0.5s` : ''}>
          <FormLabel htmlFor="email" fontWeight={'normal'} color={'white'}>
            Adresse e-mail
          </FormLabel>
          <Input id="email" type="email" placeholder="Entrez votre email" color={'black'} bg={'white'} focusBorderColor="#FFD700" value={email} onChange={handleEmailChange} isInvalid={isValideEmail && !email}errorBorderColor='crimson' />
          {/* <FormHelperText align={'start'}>Nous ne partagerons jamais votre mail</FormHelperText> */}
        </FormControl>
        <FormControl p={useBreakpointValue({ base: '2', md: '4' })} mb="3%" animation={isValideCity && !city ? `${shake} 0.5s` : ''}>
          <FormLabel htmlFor="city" fontWeight={'normal'} color={'white'}>
            Ville ou région
          </FormLabel>
          <Input id="city" placeholder="Entrez votre ville ou région" color={'black'} bg={'white'} focusBorderColor="#FFD700" value={city} onChange={handleCityChange} isInvalid={isValideCity && !city} errorBorderColor='crimson' />
        </FormControl> 
        <Box p={useBreakpointValue({ base: '2', md: '4' })} mt={useBreakpointValue({ base: '6', md: '8' })} align={'center'}>
          <Button
            bg={'#FFD700'}
            rounded={'full'}
            color={'black'}
            _hover={{ 
              bg: '#ffd900cc',
              transform: 'translateY(-2px)',
              boxShadow: 'lg', 
            }}
            onClick={handleButtonClick}
          >
            Rejoins-nous maintenant
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default Form;